<div class="tw-flex tw-justify-items-start tw-items-center tw-p-4 tw-pr-4  tw-space-x-4 tw-sticky tw-top-0 linkbar">
  <button (click)="scrollToContent('businessPersonnel')">Business Personnel</button>
  <button (click)="scrollToContent('businessDetails')">Business Details</button>
  <button (click)="scrollToContent('businessContact')">Business Contact</button>
  <button (click)="scrollToContent('monthlyTotals')">Monthly Totals</button>
</div>
<div *ngIf="borrower$ | async as borrower">
  <div #businessPersonnel class="overviewItem">
    <h3 class="!tw-mb-0 tw-pt-4 tw-pl-2 tw-border-b-2 !tw-font-bold">Business Personnel</h3>
    <div *ngFor="let contact of (allContacts$ | async) let index = index">
      <mat-divider *ngIf="index > 0"></mat-divider>
      <app-business-personnel-basic
        [contact]="contact"
        [excludes]="contactAttributeExcludes"
      ></app-business-personnel-basic>
    </div>
    <mat-divider></mat-divider>
  </div>

  <div #businessDetails class="overviewItem">
    <app-borrower-values-list-smart
      [borrower]="borrower"
      [title]="'Business Details'"
      [fields]="detailFields"
      [basicStyle]="true"
    ></app-borrower-values-list-smart>
  </div>

  <div #businessContact class="overviewItem">
    <app-borrower-values-list-smart
      [borrower]="borrower"
      [title]="'Business Contact'"
      [fields]="contactFields"
      [basicStyle]="true"
    ></app-borrower-values-list-smart>
  </div>

  <div #monthlyTotals class="overviewItem">
    <h3 class="!tw-mb-0 tw-pt-8 tw-pl-2 tw-border-b-2 !tw-font-bold">Monthly Totals</h3>
    <app-monthly-totals-card-smart
      class="tw-mt-6"
      [inContainer]="false"
      [borrowerId]="borrower.id"
      [basicStyle]="true"
    ></app-monthly-totals-card-smart>
  </div>
</div>
